<template>
	<div class="relation">
		<HNB></HNB>
		<div class="bacDiv" :style="bacImg">
			<div class="titleText">
				<div class="svgRelation"><SvgIcon svg-name="lfSignRelation" size="45"></SvgIcon></div>
				<div class="svgtitle">{{title}}</div>
			</div>
			<div class="information" v-for="item in informationAry">
				<SvgIcon :svg-name="item.icon" size="20"></SvgIcon>
				<span v-if="item.icon != 'telephone'" class="nameText">{{item.name}}</span>
				<a v-if="item.icon === 'telephone'" class="nameText" :href="'tel:' + item.name">{{item.name}}</a>
			</div>
			<div class="QRcode">
				<div class="QRcodeIcon" v-for="item in qrcode">
					<img :src="item.imgurl" />
					<div class="QRcodeText">{{item.name}}</div>
				</div>
			</div>
		</div>
		
		<bottom :BsTitle="bsTitle"></bottom>
	</div>
</template>

<script>
	import HNB from '../components/HeaderNavigationBar.vue'
	import bottom from '../components/Bottom.vue'
	import SvgIcon from '../components/SvgIcon.vue'
	export default{
		name:'relation',
		data(){
			return{
				bsTitle: ['服务支持', '联系方式'],
				bacImg: 'background-image: url(' + this.GLOBAL.imgHost + 'images/relationImages/LFbowen.png);',
				title: '厦门乐范健康科技有限公司',
				informationAry:[{
						icon:'place',
						name:'厦门市湖里区高新园安岭路35号',
					},{
						icon:'telephone',
						name:'400-101-8969',
					},{
						icon:'email',
						name:'service@lfwellness.cn',
					},],
				qrcode:	[
					{
						imgurl: this.GLOBAL.imgHost +'/images/relationImages/LFvxQRcode.png',
						name:'微信公众号',
					},{
						imgurl: this.GLOBAL.imgHost +'/images/relationImages/LFvbQRcode.png',
						name:'新浪微博',
					},
				],
			} 
		},
		components:{
			HNB,
			bottom,
			SvgIcon
		}
	}
	
</script>
	
<style>

	.relation{
		max-width: 33.75rem;
		margin: 0 auto;
	}
	
	.bacDiv {
		width: 100%;
		height: 34.5625rem;
		background-color: rgba(0,199,133,1);
		display: flex;
		align-items: flex-start;
		flex-direction: column;
		justify-content: center;
		background-repeat: no-repeat;/* 不平铺 */
		background-position:50% 20% ; /*居中*/
		background-size: 95%;
		/* margin: 0 auto;
		height: 28.375rem; */
	}
	
	.bacDiv .information {
		height: 2.0rem;
		display: flex;
		padding-left: 14%;
		flex-direction: row;
		align-items: center;
		width: 100%;
		padding-bottom: 1.125rem;
		box-sizing: border-box;
	}
	
	.bacDiv .titleText {
		align-self: center;
		padding-bottom: 1.125rem;
		margin-top:-4.25rem;
		font-size: 1.5rem;
		display: flex;
		flex-direction: row;
	}
	
	.bacDiv .titleText .svgRelation {
		margin-right: -0.55rem ;
	}
	
	.bacDiv .titleText .svgtitle {
		margin-top: 0.25rem ;
		margin-left: -1.25rem ;
		font-size: 1.5rem;
		color: white;
		font-weight: 800;
		font-family:Alibaba-PuHuiTi-M;
	}
	
	.bacDiv .information .nameText {
		padding-left: 5%;
		height: 1.5rem;
		padding-bottom: 0.25rem;
		font-weight: 400;
		color: white;
		text-decoration: underline;
		text-decoration-color: white;
		text-decoration-skip-ink: none;
		font-family:Alibaba-PuHuiTi-R;
	}
	
	.bacDiv .QRcode {
		/* background-color: yellow; */
		width: 90%;
		height: 9.25rem;
		display: flex;
		justify-content: flex-start;
		flex-direction: row;
		margin-top: -2.25rem ;
		align-self: center;
	}
	
	.bacDiv .QRcode .QRcodeIcon {
		width: 5rem;
		height: 6rem;
		padding-top: 2.625rem;
		padding-left: 2rem;
	}
	
	.bacDiv .QRcode .QRcodeIcon img {
		width:4.0625rem;
		height: 4.0625rem;
	}
	
	.bacDiv .QRcode .QRcodeIcon .QRcodeText {
		color: white;
		font-family:Alibaba-PuHuiTi-R;
		font-size: 0.75rem;
	}

	
	
	
</style>
